import React from "react";

import { useTranslation } from "utils";

import { Flex, Icon } from "components";

export const ImpactPanelErrorView = () => {
  const { t } = useTranslation(["fieldTimeline"]);

  return (
    <div data-testid="field-timeline-result-card-error" className="field-timeline-result-card margin-top-200">
      <div className="field-timeline-result-card container empty">
        <Flex vertical={true} align="center" justify="center" style={{ height: "100%" }}>
          <Icon dataTestId="field-timeline-result-card-error-tractor-icon" className="margin-bottom-100" iconName="tabler/tractor" size="xl" />
          <p data-testid="field-timeline-result-card-error-title" className="field-timeline-result-card-empty-title">
            {t("impactPanel.errorTitle")}
          </p>
          <span data-testid="field-timeline-result-card-error-description" className="field-timeline-result-card-empty-payout-description padding-100">
            {t("impactPanel.errorDescription")}
          </span>
        </Flex>
      </div>
    </div>
  );
};
